import React from 'react';

import { BackButton } from 'components/ui';

import styles from './AddPayment.module.scss';
import clsx from 'clsx';
import StripeModal from 'components/ui/Modal/StripeModal';

interface PropTypes {
  isModal?: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
  className?: string;
}

export const AddPayment: React.FC<PropTypes> = ({ isModal, className, onClose }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <>
      {!isModal && <BackButton className={styles.back} />}
      <div className={clsx('mt-3 row', className)}>
        <div className="col-12">
          <h1>Should be Payment Element</h1>
          <StripeModal modalStates={[isOpen, setIsOpen]} />;
        </div>
      </div>
    </>
  );
};
